import { Controller } from "stimulus"
import { EventTrackerService } from "../services/event_tracker_service"

export default class extends Controller {
  static targets = ["stressLevelField"]

  track(event) {
    const element = event.currentTarget

    if (element.dataset.eventTracked) return
    element.dataset.eventTracked = "true"

    if (!this.hasStressLevelFieldTarget) return

    const stressLevel = this.stressLevelFieldTarget.value
    if (!stressLevel) return

    const eventTracker = new EventTrackerService()
    eventTracker.initialize()
    eventTracker.trackEvent(
      "Savings Pledge | confidence_survey_submitted",
      { stress_level: parseInt(stressLevel, 10) },
      element
    )
  }
}
